<script setup lang="ts">
import AuthLayout from '../layouts/auth-layout.vue'
</script>

<template>
  <AuthLayout>
    <template v-slot:icon>
      <svg width="72" height="96" viewBox="0 0 72 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M63 39H9C5.68629 39 3 41.6863 3 45V87C3 90.3137 5.68629 93 9 93H63C66.3137 93 69 90.3137 69 87V45C69 41.6863 66.3137 39 63 39Z"
          fill="#111827"
          stroke="#111827"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 39V24C15 12.4 24.4 3 36 3C47.56 3 57 12.4 57 24V39"
          stroke="#111827"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M36 60V72" stroke="white" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </template>

    <div class="w-full sm:w-[380px]">
      <header>
        <h1 class="text-3xl leading-9 text-gray-900">Verify Email</h1>
        <p class="mt-6 text-gray-700">Success! Kindly check your email for the verification link.</p>
      </header>
      <main class="sm:mt-18 mt-12">
        <div class="text-center text-sm">
          Already have an account?
          <RouterLink class="ml-1 font-semibold text-[#3D8A9D]" :to="{ name: 'login' }">Login</RouterLink>
        </div>
      </main>
    </div>
  </AuthLayout>
</template>
